export default "__VITE_ASSET__yI82m_$0__"